<template>
    <div>
      <div id="stats-table" class="data-table" border="1">
        <div class="header">
          <div style="display:flex;padding: 10px;justify-content: center; align-items: center;">Skill</div>
          <div style="display:flex;padding: 10px;justify-content: space-between; align-items: center;">
            <div style="font-weight: bold;">Company: {{ company.name }}</div>
            <div>Jobs <select v-model="configType">
              <option value="label">Visibility config type: labels</option>
              <option value="blacklist">Visibility config type: blacklist</option>
          </select></div></div>
        </div>
        <div v-for="skill in skills" v-bind:key="skill.id" class="rowrow">
          <div class="cell" :style="skill.label != 'none' ? 'background-color:#bb99bb' : ''">
            <router-link :to="{ name: 'skillPage', params: { id: skill.id }}">{{skill.localizedTitle[selectedLanguage]}}</router-link>
            <span v-if="company.callOutFee"> {{ (skill.hourlyRate2[company.country][currency] / 100 / 0.8).toFixed(2) }} {{ currency }}/hour</span>
            <span v-else> {{ (skill.hourlyRate[company.country][currency] / 100 / (1 - company.feePercentage)).toFixed(2) }} {{ currency }}/hour</span>
            <div style="margin-top:15px">Call Out Fee <input v-model="skill.callOutFee" :placeholder="company.callOutFee / 100" /></div>
            <div style="margin-top:10px" v-if="configType === 'label'">
              Label:
              <select v-model="skill.label">
                <option value="none" >HIDDEN</option>
                <option v-for="label in labels" :key="label.id" :value="label.id" >{{ label.localizedTitle.lt }}</option>
              </select>
            </div>
          </div>
          <div class="cell" style="padding: 0; margin: 0">
            <div class="job-stats-table data-table" v-if="skill.jobs.length">
              <div class="header">
                <div>Name</div><div>Old</div><div>Base</div><div>Price</div><div v-if="configType !== 'label'">Enabled</div><div v-if="configType === 'label'">Label</div>
              </div>
              <div v-for="job in skill.jobs" v-bind:key="job.id" class="row">
                <div class="cell">
                  {{job.localizedTitle[selectedLanguage]}}
                  <div>
                    <input style="width: 400px" v-model.trim="job.adjustedTitle" />
                  </div>
                </div>
                <div class="cell">
                  {{ (job.unitPriceAmountOld / (1 - (job.feePercentage ? job.feePercentage / 100 : company.feePercentage)) / 100).toFixed(2) }}
                </div>
                <div class="cell">
                  {{(job.unitPriceAmount / 100).toFixed(2)}} {{currency}}
                </div>
                <div class="cell">
                  <input type="number" v-model="job.adjustedPrice" style="width: 100px" :placeholder="(job.unitPriceAmount / 100 + company.callOutFee / 100).toFixed(2)" /> EUR
                </div>
                <div class="cell" v-if="configType !== 'label'">
                  <input type="checkbox" v-model="job.enabled" >
                </div>
                <div class="cell" v-if="configType === 'label'" :style="job.label !== 'none' ? 'background-color:green' : 'background-color:white'">
                  <select v-model="job.label">
                    <option value="none" >HIDDEN</option>
                    <option v-for="label in labels" :key="label.id" :value="label.id" >{{ label.localizedTitle.lt }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <button @click="exportCsv" style="background-color: white; color: #333; padding: 10px;cursor:pointer;margin-top:20px;margin-bottom: 20px">EXPORT CSV</button>
        <button @click="saveJobs" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px;margin-bottom: 20px;margin-left: 10px">SAVE</button>
      </div>
    </div>
</template>

<style scoped lang="less">
#stats-table{
  grid-template-columns: auto auto;
}
.job-stats-table {
  grid-template-columns: auto auto auto auto auto;
}
.cell {
  padding: 10px
}
.rowrow {
  display: contents;
}
input {
  border: 1px solid black;
  padding: 2px;
}
</style>

<script>
import api from '../services/api';
import dayjs from 'dayjs';

export default {
  name: 'companyJobs',
  data: function() {
    return {
      skills: [],
      selectedLanguage: 'lt',
      currency: 'EUR',
      company: {},
      configType: 'blacklist'
    }
  },
  methods: {
    async exportCsv() {
      let csvString = ['Paslauga', 'Grupė', 'Kaina'].join(';') + "\n";
      this.skills.forEach(skill => {
        if (skill.label !== 'none') {
          const columns = [
            skill.localizedTitle['lt'] + ' (valanda)',
            this.labels.find(l => l.id === skill.label).localizedTitle.lt,
            (skill.hourlyRate[this.company.country][this.currency] / 100 / (1 - this.company.feePercentage)).toFixed(2)
          ];
          csvString += columns.join(';') + "\n";
        }
        skill.jobs.forEach(job => {
          if (job.label !== 'none') {
            const columns = [
              job.adjustedTitle || job.localizedTitle['lt'],
              this.labels.find(l => l.id === job.label).localizedTitle.lt,
              (job.unitPriceAmount / (1 - (job.feePercentage ? job.feePercentage / 100 : this.company.feePercentage)) / 100).toFixed(2)
            ];
            csvString += columns.join(';') + "\n";
          }
        });
      });
      const blob = new Blob([csvString]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `services-${this.company.orderCodePrefix}-${dayjs().format('YYYY-MM-DD')}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    saveJobs: async function() {
      const jobsConfig = {};
      const skillsConfig = {};
      this.skills.forEach(s => {
        if (s.label && s.label != 'none') {
          skillsConfig[s.id] = {labels: [s.label], callOutFee: s.callOutFee ? Math.round(parseFloat(s.callOutFee)) * 100 : null};
        } else if (s.callOutFee) {
          skillsConfig[s.id] = {labels: [], callOutFee: s.callOutFee ? Math.round(parseFloat(s.callOutFee) * 100) : null};
        }
        s.jobs.forEach(j => {
          const jobConfig = {};
          if (j.adjustedPrice) {
            const adjustedPrice = Math.round(parseFloat(j.adjustedPrice) * 100);
            if (this.company.country === 'PL') {
              jobConfig.targetPrice = adjustedPrice;
            } else {
              jobConfig.targetPrice = adjustedPrice;
            }
          }
          if (this.configType === 'blacklist') {
            if (!j.enabled) {
              jobConfig.state = 'hidden';
            }
          } else {
            if (j.label && j.label != 'none') {
              jobConfig.labels = [j.label];
            }
          }
          if (j.adjustedTitle) {
            jobConfig.localizedTitle = {[this.company.country.toLowerCase()]: j.adjustedTitle};
          }
          if (Object.keys(jobConfig).length) {
            jobsConfig[j.id] = jobConfig;
          }
        });
      });
      await api.saveCompanyJobConfig(this.$route.params.id, {visibilityConfigType: this.configType, jobConfig: jobsConfig, skillConfig: skillsConfig});
      window.location.reload();
    }
  },
  created: async function() {
    const skills = this.$store.state.skills;
    const jobs = this.$store.state.jobs;
    this.labels = this.$store.state.labels;
    // console.log(this.labels);
    // this.configType = 'label';
    const companyId = this.$route.params.id;
    this.company = await api.getCompany(companyId);
    document.title = this.company.name + ' prices';
    this.configType = this.company.visibilityConfigType || 'blacklist';
    const jobConfig = this.company.jobConfigList.reduce((prev, next) => {
      prev[next.jobId] = next;
      return prev;
    }, {});
    const skillConfig = this.company.skillConfigList.reduce((prev, next) => {
      prev[next.skillId] = next;
      return prev;
    }, {});
    if (this.company.country === 'PL') {
      this.currency = 'PLN';
    }
    this.skills = Object.values(skills).filter(s => s.hourlyRate).map(skill => {
      let s = {...skill};
      if (skillConfig[s.id] && skillConfig[s.id].labelsList && skillConfig[s.id].labelsList.length) {
        s.label = skillConfig[s.id].labelsList[0];
      } else {
        s.label = 'none';
      }
      if (skillConfig[s.id] && skillConfig[s.id].callOutFee) {
        s.callOutFee = skillConfig[s.id].callOutFee / 100;
      }
      s.hourlyRate = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, s.hourlyRate || {});
      s.hourlyRate2 = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, s.hourlyRate2 || {});
      s.numPros = {};
      s.numTotalBusinessPros = {};
      s.numCalendarPros = {};
      s.jobs = Object.values(jobs).map(job => {
        // directly modifying job caused bug
        const j = {...job};
        j.unitPrice = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, j.unitPrice || {});
        j.unitPrice2 = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, j.unitPrice2 || {});
        if (this.company.country === 'PL') {
          j.unitPriceAmountOld = j.unitPrice.LT.EUR;
        } else {
          j.unitPriceAmountOld = j.unitPrice.LT.EUR;
        }
        if (this.company.country === 'PL') {
          j.unitPriceAmount = j.unitPrice2.PL.PLN / 0.8;
        } else {
          j.unitPriceAmount = j.unitPrice2.LT.EUR / 0.8;
        }
        if (jobConfig[j.id] && jobConfig[j.id].feePercentage) {
          j.feePercentage = (jobConfig[j.id].feePercentage * 100).toFixed(3);
        }
        if (jobConfig[j.id] && jobConfig[j.id].targetPrice) {
          j.adjustedPrice = (jobConfig[j.id].targetPrice / 100).toFixed(2);
        }
        j.label = 'none';
        if (jobConfig[j.id] && jobConfig[j.id].labelsList.length) {
          j.label = jobConfig[j.id].labelsList[0];
          j.enabled = true;
        } else if (jobConfig[j.id] && jobConfig[j.id].state === 'hidden') {
          j.enabled = false;
        } else {
          j.enabled = true;
        }
        if (jobConfig[j.id] && jobConfig[j.id].localizedTitle) {
          j.adjustedTitle = jobConfig[j.id].localizedTitle[this.company.country.toLowerCase()];
        }
        return j;
      }).filter(job => {
        return job.skillId == s.id;
      }).sort((s1, s2) => {
        return s1.id < s2.id;
      });
      return s;
    })/*.filter(s => this.configType === 'label' ? true :  s.jobs.length)*/.sort((s1, s2) => {
      if ( s1.serviceId < s2.serviceId ){
        return -1;
      }
      if ( s1.serviceId > s2.serviceId ){
        return 1;
      }
      return 0;
    });
  }
}

</script>